$shm_markdown_text_list $mol_text_list
	Continuation* $mol_paragraph
		sub <= block_content*
